import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

import useQuery from './useQuery'

export default function usePatient(id, options = {}) {
  return useQuery({
    queryKey: QK.patients.id(id).details,
    queryFn: () => API.patients.id(id).details(),
    ...options,
  })
}
